/* eslint-disable jsx-a11y/alt-text */
import React from "react";
import BasicLayout from "../../layouts/BasicLayout";
import { Chefs } from "../../constants/InfoChef";
import { Link } from "react-router-dom";

const Chef = () => {
  return (
    <div className="my-8">
      <BasicLayout>
        <div className="grid grid-cols-12 gap-8">
          {Chefs.map((item, index) => {
            return (
              <div className="lg:col-span-4 md:col-span-6 col-span-12 bg-white text-sm">
                <div className="w-[100%] relative overflow-hidden">
                  <div className="pt-[100%]">
                    <img
                      className={`absolute top-0 left-0 bottom-0 right-0 w-full h-full object-fill rounded`}
                      src={item.img}
                    ></img>
                  </div>
                </div>
                <div className="px-2 pb-2">
                  <div className="text-[16px]  p-[12px_8px_4px_2px] font-semibold fo leading-5 text-primary ellipsis-2 transition">
                    <span className="inline-block mr-1">{item.name}</span>
                    <span>{item.nativeLand}</span>
                    <span className="inline-block ml-1">
                      {item.YearOfBirth}
                    </span>
                  </div>
                  <div className="p-y[10px]">
                    <span className="font-semibold mr-1">Chức vụ:</span>
                    <span>{item.position}</span>
                  </div>
                  <div>
                    <span className="font-semibold mr-1">
                      Địa chỉ nhà hàng:
                    </span>
                    <span>{item.addressRestaurant}</span>
                  </div>
                  <div>
                    <span className="font-semibold mr-1">Facebook:</span>
                    <Link
                      className="underline  hover:text-primary"
                      to={item.link}
                    >
                      {item.textLink}
                    </Link>
                  </div>
                  <div>
                    <span className="font-semibold mr-1">Telephone:</span>
                    <a className="underline" href={`tel:${item.telephone}`}>
                      {item.telephone}
                    </a>
                  </div>
                  <div>
                    <span className="font-semibold mr-1">Sự miêu tả:</span>
                    <span>{item.decription}</span>
                  </div>
                  <span className="italic font-semibold text-[#6e6e86]">
                    (kính mời quý khách qua nhà hàng để trải nghiệm những món
                    tuyệt vời nhất cùng đầu bếp)
                  </span>
                </div>
              </div>
            );
          })}
        </div>
      </BasicLayout>
    </div>
  );
};

export default Chef;
